module.exports = require("@swa-ui/core/src/LineClamp/LineClamp.module.scss");